import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EAuthType, TErrorCode } from '@datatype/type';

/**
 * auth reducer: signin/signup의 상태
 * user reducer: auth를 제외한 상태
 */

interface IState {
  // 기본정보
  authType: EAuthType | null;
  username: string | null;
  email: string | null;
  // 페이지
  isSigninPage: boolean;
  isSignupPage: boolean;
  isSignoutPage: boolean;
  isFindIdPage: boolean;
  isFindPasswordPage: boolean;
  isAuthCodePage: boolean;
  isMyPage: boolean;
  // 약관
  isSignupTerm: boolean;
  isMarketingTerm: boolean;
  // error
  errorCode: TErrorCode;
}

const initialState: IState = {
  // 기본정보
  authType: null,
  username: null,
  email: null,
  // 페이지
  isSigninPage: false,
  isSignupPage: false,
  isSignoutPage: false,
  isFindIdPage: false,
  isFindPasswordPage: false,
  isMyPage: false,
  isAuthCodePage: false,
  // 약관
  isSignupTerm: false,
  isMarketingTerm: false,
  // error
  errorCode: null,
};

const closePage = (state) => {
  state.isSignupPage = false;
  state.isSigninPage = false;
  state.isSignoutPage = false;
  state.isAuthCodePage = false;
  state.isFindIdPage = false;
  state.isFindPasswordPage = false;
  state.isMyPage = false;
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    // 기본정보
    writeEmail: (state, action: PayloadAction<string>) => {
      state.errorCode = null;
      state.email = action.payload.trim();
    },
    // 약관
    checkSignupTerm: (state, action: PayloadAction<boolean>) => {
      state.isSignupTerm = action.payload;
    },
    checkMarketingTerm: (state, action: PayloadAction<boolean>) => {
      state.isMarketingTerm = action.payload;
    },
    // page event
    openAuthCodePage: (state) => {
      closePage(state);
      state.isAuthCodePage = true;
    },
    openSigninPage: (state) => {
      closePage(state);
      state.isSigninPage = true;
    },
    openSignupPage: (state, action: PayloadAction<{ authType: EAuthType; email: string }>) => {
      const { authType, email } = action.payload;
      closePage(state);
      state.isSignupPage = true;
      state.authType = authType;
      state.email = email;
    },
    openSignoutPage: (state) => {
      closePage(state);
      state.isSignoutPage = true;
    },
    openFindIdPage: (state) => {
      closePage(state);
      state.isFindIdPage = true;
    },
    openFindPwPage: (state) => {
      closePage(state);
      state.isFindPasswordPage = true;
    },
    openMyPage: (state) => {
      closePage(state);
      state.isMyPage = true;
    },
    // error status
    checkErrorCode: (state, action: PayloadAction<IState['errorCode']>) => {
      state.errorCode = action.payload;
    },
  },
});

export const actions = authSlice.actions;
export default authSlice.reducer;
